module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.websiteid == '105') ? _c('div', {
    staticClass: "block employer"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header solo"
  }, [(_vm.koepellogo) ? _c('img', {
    attrs: {
      "src": '/BinairServlet?id=' + _vm.koepellogo,
      "alt": "logo van uw collectiviteit"
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.ctx + '/static/images/logo/viamijnwerk/logo-vmw.png',
      "alt": "logo Via Mijn Werk"
    }
  }), _vm._v(" "), (_vm.showbutton == 'j') ? _c('a', {
    staticClass: "btn btn-primary btn-arrow",
    attrs: {
      "role": "button",
      "href": _vm.ctx + '/uitdienst.html'
    }
  }, [_vm._v("Uit dienst melden")]) : _vm._e()])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b9871bc"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/components/logo-werkgever.vue
// module id = 124
// module chunks = 0